export default "__VITE_ASSET__C1iIhVN5__"